import React from "react";

const Icon: React.FC<{ className?: string; src: string; alt: string }> = ({
    className,
    src,
    alt,
}) => <img className={className} src={src} alt={alt} />;

export default Icon;
